import { normalizeProfileCountry } from "../constants/profileLocations";
import {
  PUBLIC_WEB_ORIGIN,
  RU_PUBLIC_WEB_ORIGIN,
} from "../native/runtime";
import { buildEventPath } from "./eventUrl";

export function buildEventShareUrl(event) {
  const path = buildEventPath(event.id, event.name);
  const country = normalizeProfileCountry(event.country);
  // A public event link belongs to the event's contour, regardless of the
  // viewer's API transport, network location, or cached native routing.
  const origin = country === "RU" ? RU_PUBLIC_WEB_ORIGIN : PUBLIC_WEB_ORIGIN;
  return `${origin}${path}`;
}
